import { gate } from 'hub-http/gates';
export const Gate = {
  GO_TO_WEBINAR_COMPONENT_MIGRATION: gate('GoToWebinar:FormSubmission:ComponentMigration'),
  MS_TEAMS_CONVERSATION_INTELLIGENCE: gate('MSTeams:ConversationIntelligence')
};
export const isUngatedGoToWebinarComponentMigration = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.GO_TO_WEBINAR_COMPONENT_MIGRATION);
};
export const isMsTeamsConversationIntelligenceUngated = gates => {
  return gates === null || gates === void 0 ? void 0 : gates.includes(Gate.MS_TEAMS_CONVERSATION_INTELLIGENCE);
};